import { Link } from "react-router-dom";
import { Column } from "react-table";
import { formatDate } from "../../api/DateUtils";
import { Grid } from "../Grid";
import { LicenceTransfersGridProps } from "./LicenceTransfersGridProps";
import { CreateStaticSelectColumnFilter } from "../../leap-components/Grid/FetchGrid/StaticSelectColumnFilter";
import {
  GetLicenceTransfersByLicenceFetchUrl,
  ILicenceTransferRow,
} from "../../api/ILicenceTransfer";

const LicenceTransfersGrid = ({
  licenceId,
  licenceProfile,
  licenceTransfersStatuses,
}: LicenceTransfersGridProps) => {
  const GetUrlForLicenceTransfer = (
    profileNumber: string,
    licenceId: string,
    licenceTransferId: string
  ) => {
    return `/licence-profile/${profileNumber}/versions/${licenceId}/licence-transfer/${licenceTransferId}`;
  };

  const getFetchUrlFactory = (relatedId: string) => {
    let fetchUrlFn = (
      pageNo: number,
      recordsPerPage: number,
      searchText: string,
      filters: any
    ) => {
      return GetLicenceTransfersByLicenceFetchUrl(
        relatedId,
        pageNo,
        recordsPerPage,
        searchText,
        filters
      );
    };

    return fetchUrlFn;
  };

  const fetchUrl = getFetchUrlFactory(licenceId);

  const tableColumnsBig: Column<Record<string, ILicenceTransferRow>>[] = [
    {
      Header: "Case No.",
      accessor: "casenumber",
      Filter: false,
      filter: "casenumber",
      Cell: (rowInfo: any) => (
        <table>
          <tr>
            <td>
              <Link
                to={GetUrlForLicenceTransfer(
                  licenceProfile.profileNo,
                  rowInfo.row.original.licenceid,
                  rowInfo.row.original.licencetransferid
                )}
              >
                {rowInfo.value}
              </Link>
            </td>
          </tr>
        </table>
      ),
    },
    {
      Header: "Proposed Transferee",
      accessor: "proposedtransfereeorganisationname",
      Filter: false,
    },
    {
      Header: "Status",
      accessor: "status",
      Filter: CreateStaticSelectColumnFilter(
        licenceTransfersStatuses.list.map((option) => option.value)
      ),
    },
    {
      Header: "Application Received Date",
      accessor: "validapplicationreceiveddate",
      Filter: false,
      filter: "includes",
      Cell: (rowInfo: any) => formatDate(rowInfo.value),
    },
    {
      Header: "Transfer Date",
      accessor: "licencetransferdate",
      Filter: false,
      filter: "includes",
      Cell: (rowInfo: any) => formatDate(rowInfo.value),
    },
  ];

  const tableColumnsSmall: Column<Record<string, ILicenceTransferRow>>[] = [
    {
      Header: "Case No.",
      accessor: "casenumber",
      Filter: false,
      filter: "casenumber",
      Cell: (rowInfo: any) => (
        <table>
          <tr>
            <td>
              <Link
                to={GetUrlForLicenceTransfer(
                  licenceProfile.profileNo,
                  rowInfo.row.original.licenceid,
                  rowInfo.row.original.licencetransferid
                )}
              >
                {rowInfo.value}
              </Link>
            </td>
          </tr>
        </table>
      ),
    },
    {
      Header: "Proposed Transferee",
      accessor: "proposedtransfereeorganisationname",
      Filter: false,
    },
  ];

  var bodyElements = (
    <div>
      <div className="d-md-none">
        <Grid
          columns={tableColumnsSmall}
          data={[]}
          fetchUrlFunction={fetchUrl}
          enablePagination={true}
          enableQuickFind={true}
        />
      </div>
      <div className="d-none d-md-block">
        <Grid
          columns={tableColumnsBig}
          data={[]}
          fetchUrlFunction={fetchUrl}
          enablePagination={true}
          enableQuickFind={true}
        />
      </div>
    </div>
  );

  return bodyElements;
};

export { LicenceTransfersGrid };
